import { useEffect } from 'react';
import { useApplicationCallbacks } from '../../../application-callbacks';
import useServiceData from '../../../../hooks/useServiceData';
import { useOnboarding } from '../../../../redux/reducer/content';
import { ONBOARDING_STORAGE_KEY, ONBOARDING_STEPS_TYPES } from '../../constants';
import { useOnboardingConditions } from './useOnboardingConditions';
import { defaultStore, stores } from '../../../../translations';

const onboardingStorageKey = [stores.kz, stores.ru].includes(defaultStore)
  ? ONBOARDING_STORAGE_KEY.MAY_2026
  : ONBOARDING_STORAGE_KEY.DEFAULT;

export default function useOnboardingInit() {
  const { get, save } = useServiceData();
  const { completedSteps } = useOnboarding();
  const { setOnboardingStarted, setCompletedStepsData, setUserModalsVisibility, setMarchModalsVisibility } =
    useApplicationCallbacks();
  const { isOnboardingAvailable } = useOnboardingConditions();

  useEffect(() => {
    if (completedSteps?.length) {
      save(onboardingStorageKey, completedSteps);
    }
  }, [completedSteps]);

  useEffect(() => {
    if (!isOnboardingAvailable) return;

    const completedStepsFromServiceData = get(onboardingStorageKey) ?? [];

    if (completedStepsFromServiceData?.length) {
      setOnboardingStarted(true);
      setCompletedStepsData(completedStepsFromServiceData);

      // В случае, если онбординг начат и пройдены два обязательных шага (START и ACTIVITY),
      // изменяем флаг отображения всех модальных окон на true
      if (
        completedStepsFromServiceData.includes(ONBOARDING_STEPS_TYPES.START) &&
        completedStepsFromServiceData.includes(ONBOARDING_STEPS_TYPES.ACTIVITY)
      ) {
        setUserModalsVisibility(true);

        // Отличается от остальных модалок тк по условию если онбординг начат, то не показываем модалки в этой сессии,
        // а только при инициализации и если пройдены два обязательных шага (START и ACTIVITY)
        setMarchModalsVisibility(true);
      }
    }
  }, [isOnboardingAvailable]);
}
